<div class="form-container">
  <form nz-form nzLayout="vertical" [formGroup]="satForm" (ngSubmit)="onSubmit()">
    
    <!-- Form Actions -->
    <nz-form-item class="flex end">
      <button 
        nz-button 
        nzType="primary" 
        type="submit"
        class="excel-button">
                <!-- [disabled]="!isFormValid" -->
        Aceptar
      </button>
    </nz-form-item>



    <!-- Tipo de Clase -->
    <nz-form-item>
      <nz-form-label nzFor="usarClaseExistente"><div class="bold-title">¿ Desea Registrar una nueva Clase ?</div></nz-form-label>
      <nz-form-control>
        <nz-switch
          id="usarClaseExistente"
          formControlName="usarClaseExistente"
          nzCheckedChildren="No"
          nzUnCheckedChildren="Si"
          class="red-switch">
        </nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- Clase Existente (solo si el switch está activado) -->
    <nz-form-item *ngIf="satForm.get('usarClaseExistente')?.value">
      <nz-form-label nzFor="claseId"><div class="bold-title">Clase Existente:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="claseIdErrorTpl">
        <nz-select
          id="claseId"
          formControlName="claseId"
          nzPlaceHolder="Selecciona una clase existente">
          <nz-option
            *ngFor="let clase of clasesExistentes"
            [nzValue]="clase.id"
            [nzLabel]="clase.descripcion + ' (' + clase.categoria + ')'">
          </nz-option>
        </nz-select>
        <ng-template #claseIdErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            Debes seleccionar una clase existente
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Campos para Nueva Clase (solo si el switch está desactivado) -->
    <div *ngIf="!satForm.get('usarClaseExistente')?.value">
      <!-- Descripción de la Nueva Clase -->
      <nz-form-item>
        <nz-form-label nzFor="claseDescripcion"><div class="bold-title">Descripción de la Clase</div></nz-form-label>
        <nz-form-control [nzErrorTip]="claseDescripcionErrorTpl">
          <input
            id="claseDescripcion"
            nz-input
            formControlName="claseDescripcion"
            nzPlaceHolder="Ingresa la descripción de la nueva clase">
          <ng-template #claseDescripcionErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              La descripción de la clase es obligatoria
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Categoría de la Nueva Clase -->
        <nz-form-item>
        <nz-form-label nzFor="claseCategoria"><div class="bold-title">Categoría de la Clase:</div></nz-form-label>
        <nz-form-control [nzErrorTip]="claseCategoriaErrorTpl">
          <input
            id="claseCategoria"
            nz-input
            formControlName="claseCategoria"
            nzPlaceHolder="Ingresa la categoría de la clase">
          <ng-template #claseCategoriaErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              La categoría de la clase es obligatoria
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Código Inicio de la Nueva Clase -->
      <nz-form-item>
        <nz-form-label nzFor="claseCodigoInicio"><div class="bold-title">Código Inicio de la Clase:</div></nz-form-label>
        <nz-form-control [nzErrorTip]="claseCodigoInicioErrorTpl">
          <input
            id="claseCodigoInicio"
            nz-input
            formControlName="claseCodigoInicio"
            nzPlaceHolder="Ingresa el código de inicio de la clase"
            maxlength="8">
          <ng-template #claseCodigoInicioErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              El código de inicio de la clase es obligatorio
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Código Fin de la Nueva Clase -->
      <nz-form-item>
        <nz-form-label nzFor="claseCodigoFin"><div class="bold-title">Código Fin de la Clase:</div></nz-form-label>
        <nz-form-control [nzErrorTip]="claseCodigoFinErrorTpl">
          <input
            id="claseCodigoFin"
            nz-input
            formControlName="claseCodigoFin"
            nzPlaceHolder="Ingresa el código de fin de la clase"
            minlength="8"
            maxlength="8">
          <ng-template #claseCodigoFinErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              El código de fin de la clase es obligatorio
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Descripción -->
    <nz-form-item>
      <nz-form-label nzFor="descripcion"><div class="bold-title">Descripción:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="descripcionErrorTpl">
        <input
          id="descripcion"
          nz-input
          formControlName="descripcion"
          nzPlaceHolder="Ingresa la descripción del concepto">
        <ng-template #descripcionErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La descripción es obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Tipo de Código y Estado en una fila -->
    <div nz-row nzGutter="16">
      <!-- Tipo de Código -->
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="esRango"><div class="bold-title">Tipo de Código:</div></nz-form-label>
          <nz-form-control>
            <nz-radio-group id="esRango" formControlName="esRango">
              <label nz-radio [nzValue]="false">Código Exacto</label>
              <label nz-radio [nzValue]="true">Rango de Códigos</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <!-- Estado -->
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="esValido"><div class="bold-title">Estado:</div></nz-form-label>
          <nz-form-control>
            <nz-switch
              id="esValido"
              formControlName="esValido"
              nzCheckedChildren="Válido"
              nzUnCheckedChildren="Inválido"
              class="red-switch">
            </nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Código Exacto (solo si no es rango) -->
    <nz-form-item *ngIf="!satForm.get('esRango')?.value">
      <nz-form-label nzFor="codigoExacto"><div class="bold-title">Código Exacto:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="codigoExactoErrorTpl">
        <input
          id="codigoExacto"
          nz-input
          formControlName="codigoExacto"
          nzPlaceHolder="Ingresa el código exacto"
          minlength="8"
          maxlength="8">
        <ng-template #codigoExactoErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El código exacto es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('rangeError')">
            El código debe estar entre {{ control.errors['rangeError'].min }} y {{ control.errors['rangeError'].max }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Código Inicio (solo si es rango) -->
    <nz-form-item *ngIf="satForm.get('esRango')?.value">
      <nz-form-label nzFor="codigoInicio"><div class="bold-title">Código Inicio:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="codigoInicioErrorTpl">
        <input
          id="codigoInicio"
          nz-input
          formControlName="codigoInicio"
          nzPlaceHolder="Ingresa el código de inicio"
          minlength="8"
          maxlength="8">
        <ng-template #codigoInicioErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El código de inicio es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('rangeError')">
            El código debe estar entre {{ control.errors['rangeError'].min }} y {{ control.errors['rangeError'].max }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Código Fin (solo si es rango) -->
    <nz-form-item *ngIf="satForm.get('esRango')?.value">
      <nz-form-label nzFor="codigoFin"><div class="bold-title">Código Fin:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="codigoFinErrorTpl">
        <input
          id="codigoFin"
          nz-input
          formControlName="codigoFin"
          nzPlaceHolder="Ingresa el código de fin"
          minlength="8"
          maxlength="8">
        <ng-template #codigoFinErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El código de fin es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('rangeError')">
            El código debe estar entre {{ control.errors['rangeError'].min }} y {{ control.errors['rangeError'].max }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

  </form>
</div>
